import { Sheet, AppAction } from '../types';
import { SheetStorage } from '../utils/StorageUtils';

/**
 * シートを選択する
 * @param sheetId 選択するシートのID
 * @param dispatch Reducerのdispatch関数
 */
export const selectSheet = async (sheetId: string, dispatch: React.Dispatch<AppAction>): Promise<void> => {
  dispatch({ type: 'SET_ACTIVE_SHEET', payload: sheetId });
  
  try {
    await SheetStorage.saveActiveSheetId(sheetId);
  } catch (err) {
    console.error('アクティブシートIDの保存に失敗しました:', err);
  }
};

/**
 * シートのタイトルを更新する
 * @param sheetId 更新するシートのID
 * @param newTitle 新しいタイトル
 * @param sheets 全シートの配列
 * @param dispatch Reducerのdispatch関数
 */
export const updateSheetTitle = async (
  sheetId: string, 
  newTitle: string, 
  sheets: Sheet[], 
  dispatch: React.Dispatch<AppAction>
): Promise<void> => {
  const sheet = sheets.find(s => s.id === sheetId);
  if (!sheet) return;
  
  const updatedSheet = {
    ...sheet,
    title: newTitle,
    lastModified: new Date()
  };
  
  dispatch({ type: 'UPDATE_SHEET', payload: updatedSheet });
  
  // 永続化
  try {
    await SheetStorage.saveSheet(updatedSheet);
  } catch (err) {
    console.error('シートの保存に失敗しました:', err);
  }
};

/**
 * シートを削除する
 * @param sheetId 削除するシートのID
 * @param sheets 全シートの配列
 * @param dispatch Reducerのdispatch関数
 * @returns 削除が成功したかどうか
 */
export const deleteSheet = async (
  sheetId: string, 
  sheets: Sheet[], 
  dispatch: React.Dispatch<AppAction>
): Promise<boolean> => {
  
  // if (!window.confirm('このシートを削除してもよろしいですか？')) {
  //   return false;
  // }
  
  dispatch({ type: 'DELETE_SHEET', payload: sheetId });
  
  // 永続化
  try {
    await SheetStorage.deleteSheet(sheetId);
    return true;
  } catch (err) {
    console.error('シートの削除に失敗しました:', err);
    return false;
  }
};

/**
 * シートを更新する（パウチやグループの追加・削除・変更など）
 * @param sheet 更新するシート
 * @param dispatch Reducerのdispatch関数
 */
export const updateSheet = async (sheet: Sheet, dispatch: React.Dispatch<AppAction>): Promise<void> => {

  const updatedSheet = {
    ...sheet,
    lastModified: new Date()
  };
  
  
  dispatch({ type: 'UPDATE_SHEET', payload: updatedSheet });
  
  // 永続化
  try {
    
    await SheetStorage.saveSheet(updatedSheet);
    
  } catch (err) {
    console.error('シートの保存に失敗しました:', err);
  }
}; 